import { Flex, Image } from '@chakra-ui/react';
import { AssetType } from '@llx/common';
import { Asset } from '@llx/common';
import { AnimatePresence } from 'motion/react';
import { motion } from 'motion/react';

import APP_CONSTANTS from '@/utils/constants/app.constants';

import HostIsHereAnimation from '../HostImageWrapper/HostImageWrapper';

const MotionFlex = motion.create(Flex);

type Props = {
  assetList: Asset[];
  currentIndex: number;
  onChangeIndex: (index: number) => void;
  currentHostAssetID: string | null | undefined;
  shouldShowHostAsset: boolean;
};

function AssetListPreview({
  onChangeIndex,
  assetList,
  currentIndex,
  currentHostAssetID,
  shouldShowHostAsset,
}: Props) {
  const currentHostAssetIdx = assetList.findIndex((asset) => asset.id === currentHostAssetID);
  const isCurrentlyOnHostAsset = currentHostAssetIdx === currentIndex;

  return (
    <Flex gap={3} m={4} data-testid="asset-list-preview">
      {assetList.map((elem, idx) => {
        return (
          <Flex
            boxSize={16}
            key={elem.id}
            borderRadius={3}
            position="relative"
            overflow="hidden"
            border="2px solid"
            borderColor={idx === currentIndex ? 'livelinx.orange200' : 'transparent'}
            cursor="pointer"
            onClick={() => onChangeIndex(idx)}
            alignItems="center"
            justifyContent="center"
            bg="white"
            boxShadow="whiteShadow"
            data-testid="asset-list-preview-item"
          >
            <Flex
              position="absolute"
              width="100%"
              height="100%"
              zIndex={1}
              bg={idx === currentIndex ? 'livelinx.orange200Opacity40' : 'transparent'}
              alignItems="center"
              justifyContent="center"
            />
            <AnimatePresence>
              {shouldShowHostAsset && idx === currentHostAssetIdx && !isCurrentlyOnHostAsset && (
                <MotionFlex
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  exit={{ scale: 0 }}
                  transition={
                    APP_CONSTANTS.SHOW_ANIMATIONS
                      ? { duration: 0.3, ease: 'easeInOut' }
                      : { duration: 0 }
                  }
                  position="absolute"
                  width="100%"
                  height="100%"
                  zIndex={1}
                  justifyContent="center"
                  alignItems="center"
                >
                  <HostIsHereAnimation />
                </MotionFlex>
              )}
            </AnimatePresence>
            <Image src={elem.type === AssetType.IMAGE ? elem.url : elem.thumbUrl} />
          </Flex>
        );
      })}
    </Flex>
  );
}

export default AssetListPreview;
